import { defineComponent as _defineComponent } from 'vue'
import { isTouchScreen } from '@@/bits/browser'
import OzDivider, { OzDividerColorScheme, OzDividerOrientation } from '@@/library/v4/components/OzDivider.vue'
import type { WhiteboardSecondaryMenu } from '@@/types/whiteboard'
import WhiteboardSecondaryMenuIcon from '@@/vuecomponents/WhiteboardSecondaryMenuIcon.vue'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteboardSecondaryMenu',
  props: {
    mode: null,
    colorScheme: null,
    secondaryMenus: null,
    secondarySelectionIds: { default: undefined },
    iconsPerLine: { default: 3 }
  },
  emits: ['select'],
  setup(__props: any, { emit }) {

const props = __props as { mode: 'toolbar' | 'toolbarHorizontal' | 'elementModifier', colorScheme: 'dark' | 'light', secondaryMenus: WhiteboardSecondaryMenu[], secondarySelectionIds: string[], iconsPerLine: 1 | 3 };


// Emit setup

function handleSelection(item: { id: string }, secondaryMenuId: string, $event: PointerEvent): void {
  emit('select', item, secondaryMenuId, $event)
}

/**
 * RESPONSIVE
 */

const isTouch = isTouchScreen()

return { __sfc: true,props, emit, handleSelection, isTouch, OzDivider, OzDividerColorScheme, OzDividerOrientation, WhiteboardSecondaryMenuIcon }
}

})